import React from 'react';

import { JRCTypography } from 'components/JRCTypography/JRCTypography';

export const WidgetEmailsItemSubject = ({ subject, read }: { subject: string; read: boolean }) => {
    return (
        <JRCTypography weight="medium" color={read ? 'grey4' : 'grey6'}>
            {subject}
        </JRCTypography>
    );
};
